import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const requestShortCloseLineItemQuery = async ({ formValues, lineItemId }) => {
  const {
    reason,
    otherReason,
    level1Assignee,
    level2Assignee,
    remarks,
    level1RoleIdentifier,
    level2RoleIdentifier
  } = formValues;

  const payload = {
    lineItemId,
    shortCloseReasonId: reason,
    otherReason,
    remarks,
    approvers: [
      {
        roleIdentifier: level1RoleIdentifier,
        approverType: level1RoleIdentifier === 'vendor' ? 1 : 2,
        approver: level1Assignee,
        level: 1
      },
      ...(level2RoleIdentifier
        ? [{
          roleIdentifier: level2RoleIdentifier,
          approverType: level2RoleIdentifier === 'vendor' ? 1 : 2,
          approver: level2Assignee,
          level: 2
        }]
        : [])
    ]
  };
  const response = await axios.put(apiurl?.initiateShortCloseLineItem, payload);
  return response.data;
};

const requestShortCloseLineItem = () => {
  const queryClient = useQueryClient();

  return useMutation(requestShortCloseLineItemQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getPO');
    }
  });
};

export default requestShortCloseLineItem;
